import { LegalLayout } from '../components/LegalLayout';
import '../legal.css';

export function TermsPage() {
  return (
    <LegalLayout
      title="Terms of Service"
      updated="May 7, 2026"
      summary="Use Rynora to test software you own. Don't break the law, don't abuse the runners. We try hard to be fair. The full text below tightens that up."
    >
      <h2>1. The deal</h2>
      <p>
        By creating an account on rynora.app you accept these terms. If you don't agree, please don't sign up. If you
        sign up on behalf of a company, you confirm you can bind that company.
      </p>

      <h2>2. Your account</h2>
      <ul>
        <li>You are responsible for keeping your password / API tokens secret.</li>
        <li>You must give us accurate billing information.</li>
        <li>One person per login. Use organizations to add teammates.</li>
      </ul>

      <h2>3. Acceptable use</h2>
      <p>
        You agree <strong>not</strong> to use Rynora to:
      </p>
      <ul>
        <li>Test or scrape sites you don't own and don't have permission to test.</li>
        <li>Run distributed denial-of-service attacks or stress-test third-party APIs.</li>
        <li>Automate fraud, credential stuffing, or scraping behind a login wall.</li>
        <li>Process content that is unlawful, infringes IP, or sexually exploits minors.</li>
        <li>Bypass the runner concurrency cap or share a single account across many people.</li>
      </ul>
      <p>
        We will suspend accounts that breach this section, with a credit issued for unused time if the breach was
        unintentional.
      </p>

      <h2>4. Plans, billing, and refunds</h2>
      <p>
        Plan limits and pricing are listed on the <a href="/#pricing">pricing page</a>. We bill monthly or annually in
        advance. Annual subscriptions are pro-rated on cancellation. You can cancel any time from the billing page.
      </p>

      <h2>5. Service levels</h2>
      <p>
        We aim for 99.5% monthly availability on paid plans. If a calendar month falls short, we credit your next
        invoice on a sliding scale (5% credit per 0.5% missed). Free-plan usage comes with no SLA — see the{' '}
        <a href="/status">status page</a> for live numbers.
      </p>

      <h2>6. Your data, your IP</h2>
      <p>
        You own everything you send to Rynora — flows, recordings, traces, screenshots. We get a narrow license to host,
        process, and back it up so we can deliver the service. You can export and delete it at any time. We do not train
        models on your data.
      </p>

      <h2>7. Our IP</h2>
      <p>
        The Rynora platform — code, designs, brand — belongs to us. Don't copy it, don't claim it's yours. The
        MIT-licensed open-source pieces are listed in the repo.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        Rynora is provided "as is". We make no guarantee that every test will pass, that the runner will catch every
        bug, or that the AI suggestions will be perfect. Use your judgment.
      </p>

      <h2>9. Liability</h2>
      <p>
        To the maximum extent permitted by law, our total liability for any claim arising from these terms is limited to
        the amount you paid us in the 12 months before the claim.
      </p>

      <h2>10. Termination</h2>
      <p>
        Either side can terminate this agreement at any time. On termination we keep your data for 30 days so you can
        export it, then we delete it.
      </p>

      <h2>11. Changes</h2>
      <p>
        We can update these terms with 30 days' notice via email + an in-app banner. Continued use after the effective
        date counts as acceptance.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about the terms? <a href="mailto:support@rynora.app">support@rynora.app</a>.
      </p>
    </LegalLayout>
  );
}
